module.exports = __webpack_public_path__ + "img/62c142c7e4172c9a4a19e1eba1d1cd4.33a364a0.png";